module.exports = __webpack_public_path__ + "img/icon-white-59.06620844.svg";